<template lang="pug">
.maintenance-screen
  .maintenance-card
    .maintenance-icon
      b-icon-tools.icon-wrench
    h1.maintenance-title App Under Maintenance
    p.maintenance-message {{ description }}
    //- .maintenance-divider
    //- p.maintenance-contact
    //-   | For urgent matters, please contact us at
    //-   br
    //-   a(href="mailto:fow@dsg.sg") fow@dsg.sg
    .maintenance-footer
      p We apologize for the inconvenience.
      //- Staff / test accounts on the appMaintenanceBypass list can log in and
      //- use the app while maintenance is on (everyone else returns here after login).
      button.staff-login-link(type="button" @click="staffLogin") Staff login
</template>

<script>
export default {
  name: 'MaintenanceScreen',
  methods: {
    staffLogin() {
      this.$root.maintenanceStaffLogin = true;
      if (this.$route.path !== '/login') this.$router.replace('/login');
    }
  },
  computed: {
    description() {
      return this.$root.maintenanceDescription
        || 'We\'re currently performing scheduled maintenance to improve your experience. Please check back shortly.';
    }
  }
}
</script>

<style scoped>
.staff-login-link {
  margin-top: 1rem;
  background: transparent;
  border: none;
  color: #9a8fb0;
  font-size: 0.8rem;
  text-decoration: underline;
  cursor: pointer;
}

.maintenance-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #50276b 0%, #7a3d9e 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.maintenance-card {
  background: white;
  border-radius: 20px;
  padding: 40px 32px;
  max-width: 420px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.maintenance-logo {
  height: 56px;
  width: auto;
  margin-bottom: 24px;
}

.maintenance-icon {
  background: #f3e8ff;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
}

.icon-wrench {
  font-size: 36px;
  color: #50276b;
}

.maintenance-title {
  font-size: 24px;
  font-weight: 700;
  color: #50276b;
  margin-bottom: 16px;
}

.maintenance-message {
  font-size: 15px;
  color: #555;
  line-height: 1.6;
  margin-bottom: 24px;
}

.maintenance-divider {
  border-top: 1px solid #e8e0f0;
  margin-bottom: 20px;
}

.maintenance-contact {
  font-size: 14px;
  color: #777;
  margin-bottom: 0;
}

.maintenance-contact a {
  color: #50276b;
  font-weight: 600;
  text-decoration: none;
}

.maintenance-contact a:hover {
  text-decoration: underline;
}

.maintenance-footer {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e8e0f0;
}

.maintenance-footer p {
  font-size: 13px;
  color: #999;
  margin: 0;
}
</style>
